import React from 'react'
import './src/styles/global.css'
import { Provider as ToastProvider } from './src/context/Toast'
import { RouteUpdateArgs } from 'gatsby'
import { UserProvider } from './src/hooks/useUser'
import SiteLayout from './src/components/SiteLayout'
import { Provider } from './src/context/App'

export const wrapRootElement = ({ element }) => (
    <ToastProvider>
        <UserProvider>{element}</UserProvider>
    </ToastProvider>
)

export const onRouteUpdate = ({ location, prevLocation }: RouteUpdateArgs) => {
    if (typeof window !== 'undefined' && prevLocation) {
        var theme = (window as any).__theme
        if (theme) {
            document.body.className = theme
        }
    }
}

export const wrapPageElement = ({ element, props: { location } }) => {
    return (
        <Provider element={element} location={location}>
            <SiteLayout>{element}</SiteLayout>
        </Provider>
    )
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    if (location.state?.preventScroll) {
        return false
    }
    return true
}
